import React from 'react'
import _ from 'lodash'

const sources = () => {
  switch(window.COUNTRY) {
  case 'CN':
    return ["https://v.qq.com/x/page/e3235x1hivz.html"]
  case 'RU':
    return ["https://www.youtube.com/embed/oMS-avMATCA?rel=0"]
  default:
    return ["https://www.youtube.com/embed/juIDsPp6Dxo?rel=0"]
  }
}

const Videos = (props) => {
  return _.map(sources(), (src, index) => {
    return (
      <div className="video-section__iframe-wrapper" key={`video-${index}`}>
        <iframe
          className="video-section__iframe"
          allow="encrypted-media"
          frameBorder="0"
          src={src}
        />
      </div>
    )
  })
}

export default Videos
